import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  achRelationships: {
    id: 'sentinel.components.transferPanel.achRelationships',
    defaultMessage: 'ACH Relationships',
  },
  wireDetails: {
    id: 'sentinel.components.transferPanel.wireDetails',
    defaultMessage: 'Wire Details',
  },
  checkDetails: {
    id: 'sentinel.components.transferPanel.checkDetails',
    defaultMessage: 'Check Details',
  },
  feeDetails: {
    id: 'sentinel.components.transferPanel.feeDetails',
    defaultMessage: 'Fee Details',
  },
  creditDetails: {
    id: 'sentinel.components.transferPanel.creditDetails',
    defaultMessage: 'Credit Details',
  },
  amount: {
    id: 'sentinel.components.transferPanel.amount',
    defaultMessage: 'Amount',
  },
  dateRequested: {
    id: 'sentinel.components.transferPanel.dateRequested',
    defaultMessage: 'Date Requested',
  },
  disbursementType: {
    id: 'sentinel.components.transferPanel.disbursementType',
    defaultMessage: 'Disbursement Type',
  },
  full: {
    id: 'sentinel.components.transferPanel.full',
    defaultMessage: 'Full Balance',
  },
  instructionSource: {
    id: 'sentinel.components.transferPanel.instructionSource',
    defaultMessage: 'Instruction Source',
  },
  partial: {
    id: 'sentinel.components.transferPanel.partial',
    defaultMessage: 'Partial Balance',
  },
  requestedAmount: {
    id: 'sentinel.components.transferPanel.requestedAmount',
    defaultMessage: 'Requested Amount',
  },
  transfer: {
    id: 'sentinel.components.transferPanel.transfer',
    defaultMessage: 'Transfer',
  },
  transferDetails: {
    id: 'sentinel.components.transferPanel.transferDetails',
    defaultMessage: 'Transfer Details',
  },
  transferId: {
    id: 'sentinel.components.transferPanel.transferId',
    defaultMessage: 'Transfer ID',
  },
  rtpTransactionId: {
    id: 'sentinel.components.transferPanel.rtpTransactionId',
    defaultMessage: 'RTP ID',
  },
  rtp: {
    id: 'sentinel.components.transferPanel.rtp',
    defaultMessage: 'ACH Relationship',
  },
  paypal: {
    id: 'sentinel.components.transferPanel.paypal',
    defaultMessage: 'PayPal Relationship',
  },
  positionDetails: {
    id: 'sentinel.components.transferPanel.positionDetails',
    defaultMessage: 'Position Details',
  },
  destinationAccount: {
    id: 'sentinel.components.transferPanel.destinationAccount',
    defaultMessage: 'Destination Account',
  },
  journalType: {
    id: 'sentinel.components.transferPanel.journalType',
    defaultMessage: 'Journal Type',
  },
  source: {
    id: 'sentinel.components.transferPanel.source',
    defaultMessage: 'Transfer Source',
  },
});

export default messages;



// WEBPACK FOOTER //
// ./src/components/TransferPanel/messages.js